export default __webpack_public_path__ + "static/media/v2.ecc512ba.webp";